import {jsx as _jsx} from "react/jsx-runtime";
export let frontmatter = {
  "title": "Documentación",
  "description": "Centro de ayuda y notas de versión de Orkestria."
};
export let structuredData = {
  "contents": [],
  "headings": []
};
import {DocsLanding} from "@/components/docs/DocsLanding";
export let toc = [];
function _createMdxContent(props) {
  return _jsx(DocsLanding, {});
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
